import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

interface DialogData {
  image: string;
  title: string;
  message: string;
  url: string;
}

@Component({
  selector: 'app-modal-intro',
  templateUrl: './modal-intro.component.html',
  styleUrls: ['./modal-intro.component.scss'],
  imports: [CommonModule, MatIconModule, FormsModule, MatRippleModule],
  standalone: true,
})
export class ModalIntroComponent {
  private readonly hideIntroModal = 'escondeModalIntro';

  protected data = inject<DialogData>(DIALOG_DATA);

  protected esconderVideo = localStorage.getItem(this.hideIntroModal) == 'true';

  protected dialogRef = inject(DialogRef<ModalIntroComponent>);

  ngOnInit(): void {
  }

  protected changeNaoMostrarNovamente() {
    this.esconderVideo = !this.esconderVideo;
    localStorage.setItem(
      this.hideIntroModal,
      this.esconderVideo ? 'true' : 'false'
    );
  }

  protected navigateUrl() {
    window.open(this.data.url);
  }
}
